var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"edit-delete-issue-button"},[_c('div',{staticClass:"action edit"},[_c('v-icon',{on:{"click":function($event){return _vm.editIssue()}}},[_vm._v("edit")])],1),_c('div',{staticClass:"action delete"},[_c('v-icon',{on:{"click":_vm.deleteIssue}},[_vm._v("delete_outline")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }